import { useEffect } from 'react';
import { updateCreditsHistory } from '../../../../util/api';
import { CREDITS_ACTION_PROFILE_COMPLETE } from '../../../../credits-config';

export const useProfileCompleteEvent = ({
    onUpdateProfile,
    userId,
    mandatoryFieldsComplete,
    PD_profileComplete,
    profileComplete,
}) => {
    useEffect(() => {
        if (!userId) return;
        if (!mandatoryFieldsComplete) return;
        if (PD_profileComplete) return;
        /**
         * a user reached 100% completeness;
         * update a user's profileComplete pb data
         */
        onUpdateProfile({}, { profileComplete: true });
        updateCreditsHistory(
            JSON.stringify({
                userId,
                eventName: CREDITS_ACTION_PROFILE_COMPLETE,
            })
        );
    }, [PD_profileComplete, profileComplete, userId]);
};
